import React, { useState } from 'react';
import 'bootstrap';
import 'aos'
import '../assets/css/style.css';


const Faq = ({ product }) => {

    const [openDetails, setOpenDetails] = useState({
        open1: false,
        open2: false,
        open3: false,
        open4: false,
        open5: false,
    });

    const handleToggle = (key, e) => {
        e.preventDefault();
        
        setOpenDetails((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    const faq_data = product==='LIMS' ? faqs_lims :  product==='ELN' ? faqs_eln :  product==='QMS' ? faqs_qms :  product==='DMS' ? faqs_dms : product==='ADBS' ? faqs_adbs : product==='T-LIMS' ? faqs_tlims : product==='LIMS-ELN' ? faqs_lims_eln : faqs_saas ;

    return (
        <React.Fragment>
            <div className="faq-div">
                <h1>{product} Frequently asked questions</h1>
                <ul>
                    {faq_data.map(({ key, question, answer }) => (
                        <li key={key}>
                            <details open={openDetails[key]}>
                                <summary onClick={(e) => handleToggle(key, e)}>
                                    <div className='faq-ques'>{question}</div>
                                    <div className="plus_to_minus_container">
                                        <div className={`plus_to_minus ${openDetails[key] ? "open" : ""}`}></div>
                                    </div>
                                </summary>
                                <p style={{fontSize:'16px'}}>{answer}</p>
                            </details>
                        </li>
                    ))}
                </ul>
            </div>
        </React.Fragment>
    )
}

export default Faq


const faqs_lims = [
    {
        key: "open1",
        question: "What is a LIMS and why is it used?",
        answer: `LIMS (Laboratory Information Management System) is a software solution that helps manage samples, lab workflows, test data, and compliance in laboratories.`,
    },
    {
        key: "open2",
        question: "Can LIMS integrate with lab instruments?",
        answer: `Yes, LIMS can be integrated with instruments like HPLC, GC, and balances for automated data capture and improved accuracy.`,
    },
    {
        key: "open3",
        question: "Is LIMS configurable to different industries like pharma, food, or biotech?",
        answer: `Absolutely. LIMS platforms are modular and can be configured to suit industry-specific workflows and regulations.`,
    },
    {
        key: "open4",
        question: "Does LIMS support multi-location or remote access?",
        answer: `Yes, cloud-based LIMS allows secure access across locations, ideal for organizations with multiple labs or remote teams.`,
    },
    {
        key: "open5",
        question: "Is LIMS compliant with regulatory standards?",
        answer: `Yes, most LIMS platforms are designed to comply with 21 CFR Part 11, ISO/IEC 17025, GLP, and other global regulations.`,
    },
];

const faqs_eln = [
    {
        key: "open1",
        question: "What is an ELN and how is it different from LIMS?",
        answer: `An ELN (Electronic Lab Notebook) is used to digitally capture, organize, and search scientific experiments and research notes. Unlike LIMS, which focuses on structured workflows and compliance, ELN is more flexible for R&D and documentation of exploratory work.`,
    },
    {
        key: "open2",
        question: "Can ELN capture raw data like images, graphs, and chemical structures?",
        answer: `Yes, ELNs support attachments including images, instrument outputs, Excel files, chemical drawing tools, and graphs for complete scientific documentation.`,
    },
    {
        key: "open3",
        question: "Is data in ELN secure and compliant with regulatory standards?",
        answer: `Absolutely. ELNs offer access control, audit trails, and electronic signatures to meet compliance standards like 21 CFR Part 11 and GLP.`,
    },
    {
        key: "open4",
        question: "Can ELNs be integrated with LIMS or instruments?",
        answer: `Yes, most ELNs offer APIs or integration options to sync with LIMS, CDS (Chromatography Data Systems), or directly with instruments.`,
    },
    {
        key: "open5",
        question: "Does ELN support collaboration and version tracking?",
        answer: `Yes, multiple users can collaborate on a single experiment, with automatic version history, time stamps, and comments for traceability.`,
    }
];

const faqs_qms = [
    {
        key: "open1",
        question: "What does the QMS module in LIMS manage?",
        answer: `It manages audits, CAPAs, deviations, change controls, and ensures compliance with quality standards.`,
    },
    {
        key: "open2",
        question: "Can QMS workflows be customized?",
        answer: `Yes, QMS workflows can be configured as per your SOPs and internal quality procedures.`,
    },
    {
        key: "open3",
        question: "How are deviations handled in QMS?",
        answer: `Deviations can be logged, investigated, and escalated to CAPA with complete tracking and documentation.`,
    },
    {
        key: "open4",
        question: "Does QMS support risk assessment?",
        answer: `Yes, risk assessment tools can be integrated to evaluate and prioritize issues based on severity and impact.`,
    },
    {
        key: "open5",
        question: "Can we assign tasks and get reminders through QMS?",
        answer: `Yes, task assignments, due dates, and email reminders are part of QMS automation.`,
    }
];

const faqs_dms = [
    {
        key: "open1",
        question: "What is managed in the DMS?",
        answer: `SOPs, specifications, manuals, reports, and other quality documents are securely managed in DMS.`,
    },
    {
        key: "open2",
        question: "Can DMS handle document versioning and approvals?",
        answer: `Yes, version control, electronic approvals, and workflow routing are built-in features.`,
    },
    {
        key: "open3",
        question: "Is there access control for sensitive documents?",
        answer: `Yes, role-based permissions ensure only authorized users can access or edit documents.`,
    },
    {
        key: "open4",
        question: "Does DMS support electronic signatures?",
        answer: `Yes, compliant with 21 CFR Part 11, DMS supports electronic signatures with full audit trails.`,
    },
    {
        key: "open5",
        question: "Can we link documents from DMS to QMS or ADBS modules?",
        answer: `Absolutely. Documents can be linked to batches, CAPAs, deviations, or test methods for traceability.`,
    }
];

const faqs_adbs = [
    {
        key: "open1",
        question: "What is Lab Iconics ADBS?",
        answer: `It's an automated software solution that regularly backs up your important data to ensure it's safe from loss, corruption, or system failures.`,
    },
    {
        key: "open2",
        question: "Where is the backup data stored?",
        answer: `You can store backups on external hard drives, NAS devices, or secure cloud storage — depending on your setup.`,
    },
    {
        key: "open3",
        question: "Is my data secure with ADBS?",
        answer: `Yes, ADBS uses robust encryption to protect your data during both transfer and storage.`,
    },
    {
        key: "open4",
        question: "Can I recover my data after a system crash?",
        answer: `Absolutely. ADBS includes disaster recovery features to restore your data to the same or a different system, even a virtual machine.`,
    },
    {
        key: "open5",
        question: "Does it support automatic scheduling?",
        answer: `Yes, you can schedule backups daily, weekly, or monthly — completely automated with zero manual effort.`,
    }
];

const faqs_lims_eln = [
    {
        key: "open1",
        question: "What are the benefits of integrating LIMS and ELN?",
        answer: `It unifies sample management and experimental documentation, eliminating duplication, reducing errors, and streamlining lab workflows.`,
    },
    {
        key: "open2",
        question: "Is the system compliant with regulatory standards?",
        answer: `Yes, it fully supports 21 CFR Part 11, GLP, and other global regulations with audit trails, e-signatures, and version control.`,
    },
    {
        key: "open3",
        question: "Can the platform capture data directly from lab instruments?",
        answer: `Absolutely. It integrates with lab instruments to automatically capture and log data in both LIMS and ELN modules.`,
    },
    {
        key: "open4",
        question: "Can I customize the system for both QC and R&D needs?",
        answer: `Yes, it’s highly configurable to support distinct workflows for Quality Control, Research & Development, and other lab functions.`,
    },
    {
        key: "open5",
        question: "Is full traceability ensured from sample login to COA release?",
        answer: `Yes, every step — from sample registration to final reporting — is tracked with complete traceability and audit readiness.`,
    }
];

const faqs_tlims = [
    {
        key: "open1",
        question: "What types of labs is T-LIMS suitable for?",
        answer: `T-LIMS is designed for pharmaceutical, food, environmental, and industrial testing labs, offering compliance with standards like FDA, WHO-GMP, FSSAI, ISO 17025, and NABL.`,
    },
    {
        key: "open2",
        question: "Can T-LIMS generate regulatory-compliant Certificates of Analysis (CoAs)?",
        answer: `Yes. T-LIMS supports fast, customizable, and fully compliant CoA generation, complete with electronic signatures for audit-readiness.`,
    },
    {
        key: "open3",
        question: "How does T-LIMS help in maintaining data integrity?",
        answer: `All test data, approvals, and documents are stored in a centralized repository with full audit trails and secure e-signatures, ensuring data integrity and traceability.`,
    },
    {
        key: "open4",
        question: "Is T-LIMS cloud-based and accessible remotely?",
        answer: `Absolutely. T-LIMS is cloud-based with role-based access controls, enabling secure access from anywhere and centralized management across lab locations.`,
    },
    {
        key: "open5",
        question: "What kind of automation does T-LIMS offer?",
        answer: `T-LIMS automates workflows such as sample registration, test scheduling, analyst task tracking, inventory management boosting efficiency and accuracy.`,
    }
];

const faqs_saas = [
    {
        key: "open1",
        question: "What makes the Lab Iconics LIMS-ELN SaaS model cost-effective?",
        answer: `Lab Iconics uses a cloud-based, pay-as-you-go SaaS model that eliminates the need for costly IT infrastructure, expensive upgrades, and long deployment cycles—offering enterprise-grade features at a budget-friendly price.`,
    },
    {
        key: "open2",
        question: "How quickly can we go live with Lab Iconics SaaS LIMS-ELN?",
        answer: `The system is pre-configured and fully validated, allowing labs to go live in under 48 hours. You simply upload your metadata, and the solution is ready to use—fast, efficient, and hassle-free.`,
    },
    {
        key: "open3",
        question: "How does the Lab Iconics SaaS LIMS-ELN ensure data security and regulatory compliance?",
        answer: `With features like end-to-end encryption, secure access controls, tamper-proof audit trails, and compliance with ISO 17025 and 21 CFR Part 11, the platform guarantees data integrity, confidentiality, and audit readiness.`,
    },
    {
        key: "open4",
        question: "Can this system support remote access and collaboration across multiple lab sites?",
        answer: `Yes, Lab Iconics LIMS-ELN provides secure, anytime-anywhere access and enables real-time collaboration across locations, promoting teamwork and seamless workflow management.`,
    },
    {
        key: "open5",
        question: "How does Lab Iconics LIMS-ELN improve lab efficiency and productivity?",
        answer: `By streamlining sample tracking, automating workflows, and optimizing data management, the system reduces errors, accelerates turnaround time, and boosts overall lab productivity.`,
    }
];